(function ($) {
  'use strict'
  Drupal.behaviors.sliderComponent = {
    attach: function (context, settings) {
      const sliderOptions1 = {
        slidesPerView: 'auto',
        spaceBetween: 32,
        breakpoints: {
          1025: {
            allowTouchMove: false,
            centeredSlides: true,
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        }
      };

      const swiper1 = new Swiper('.paragraph--slider-component .swiper', sliderOptions1);
    }
  };

}) (jQuery)










